function triggerCardsInView() {
  function init() {
    const blocks = document.querySelectorAll(".case-card");

    const config = {
      // threshold: [0.5], // half of item height
      // rootMargin: "0px 0px 0px 0px",
      threshold: 1,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // make sure only one is active
          blocks.forEach((block) => {
            block.classList.remove("case-card-inview");
          });

          entry.target.classList.add("case-card-inview");
        } else {
          entry.target.classList.remove("case-card-inview");
        }
      });
    }, config);

    blocks.forEach((block) => {
      observer.observe(block);
    });
  }

  const isPresent = document.getElementsByClassName("case-card");
  if (isPresent.length > 0) {
    init();
  }
}

export { triggerCardsInView };

function tirggerInView() {
  function init() {
    const blocks = document.querySelectorAll(".observe");

    const config = {
      rootMargin: "0px 0px -100px 0px",
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("observe-inview");
        }
      });
    }, config);

    blocks.forEach((block) => {
      observer.observe(block);
    });
  }

  const isPresent = document.getElementsByClassName("observe");
  if (isPresent.length > 0) {
    init();
  }
}

export { tirggerInView };

function triggerAboutInView() {
  function init() {
    const blocks = document.querySelectorAll(".about-content-wrap");

    const config = {
      rootMargin: "-10% 0px -50% 0px",
      // threshold: 0.5,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          document.body.classList.add("about-active");
        } else {
          document.body.classList.remove("about-active");
        }
      });
    }, config);

    blocks.forEach((block) => {
      observer.observe(block);
    });
  }

  const isPresent = document.getElementsByClassName("about-content-wrap");
  if (isPresent.length > 0) {
    init();
  }
}

export { triggerAboutInView };

function triggerHeaderImgInView() {
  function init() {
    const blocks = document.querySelectorAll(".subpage-content");

    const config = {
      rootMargin: "0px 0px -30% 0px",
      // threshold: 0.5,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          document.body.classList.add("hide-subpage-header-img");
        } else {
          document.body.classList.remove("hide-subpage-header-img");
        }
      });
    }, config);

    blocks.forEach((block) => {
      observer.observe(block);
    });
  }

  const isPresent = document.getElementsByClassName("subpage-content");
  if (isPresent.length > 0) {
    init();
  }
}

export { triggerHeaderImgInView };

function triggerFooterInView() {
  function init() {
    const blocks = document.querySelectorAll(".footer");

    const config = {
      rootMargin: "0px 0px -95% 0px",
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          document.body.classList.add("footer-visible");
        } else {
          document.body.classList.remove("footer-visible");
        }
      });
    }, config);

    blocks.forEach((block) => {
      observer.observe(block);
    });
  }

  const isPresent = document.getElementsByClassName("footer");
  if (isPresent.length > 0) {
    init();
  }
}

export { triggerFooterInView };

function triggerTextScroll() {
  function init() {
    const blocks = document.querySelectorAll(".title-scroll");

    const config = {
      rootMargin: "0px 0px 0px 0px",
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          window.addEventListener("scroll", () => {
            const elem = entry.target;
            const pos = entry.target.getBoundingClientRect().bottom;

            elem.style.marginLeft = `${pos / 6}px`;
          });
        }
      });
    }, config);

    blocks.forEach((block) => {
      observer.observe(block);
    });
  }

  const isPresent = document.getElementsByClassName("title-scroll");
  if (isPresent.length > 0) {
    init();
  }
}

export { triggerTextScroll };
